function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { HStack, Text, VStack } from 'native-base';
import React from 'react';
import IconButton from '../../IconButton';
const NaturalDisasterAlertScreen = _ref => {
  let {
    logUserEvent,
    metadata: {
      heading,
      title: {
        metadata: data
      }
    },
    onSelection,
    valueKey
  } = _ref;
  return /*#__PURE__*/React.createElement(VStack, {
    space: {
      base: 69,
      lg: 12,
      md: 12,
      sm: 69
    },
    alignItems: 'center',
    justifyContent: 'center',
    flex: "1"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 12
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "lg",
    fontWeight: 500,
    color: "text.running",
    textAlign: 'center',
    accessibilityLabel: heading,
    accessibilityRole: "text",
    testID: `natural-disaster-alert-${heading}`
  }, heading), /*#__PURE__*/React.createElement(Text, {
    fontSize: 'lg',
    color: "text.running",
    textAlign: 'center',
    lineHeight: 21
  }, data.map(_ref2 => {
    let {
      text,
      textProps
    } = _ref2;
    return /*#__PURE__*/React.createElement(Text, _extends({
      key: text
    }, textProps), text);
  }))), /*#__PURE__*/React.createElement(HStack, {
    space: 4
  }, /*#__PURE__*/React.createElement(IconButton, {
    width: {
      base: 150,
      sm: 150,
      md: 240,
      lg: 240,
      xl: 240
    },
    title: "YES",
    accessibilityLabel: "Yes",
    accessibilityRole: "button",
    testID: "Alert_Screen_Yes_Button",
    onPress: () => {
      logUserEvent({
        action: 'DisasterFlowYesImpactClicked',
        type: 'NaturalDisaster',
        description: 'Yes option clicked from Natural Disaster'
      });
      onSelection({
        [valueKey]: 'Y'
      });
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    width: {
      base: 150,
      sm: 150,
      md: 240,
      lg: 240,
      xl: 240
    },
    title: "NO",
    accessibilityLabel: "No",
    accessibilityRole: "button",
    testID: "Alert_Screen_No_Button",
    variant: "freedomOutline",
    onPress: () => {
      logUserEvent({
        action: 'DisasterFlowNoImpactClicked',
        type: 'NaturalDisaster',
        description: 'No option clicked from Natural Disaster'
      });
      onSelection({
        [valueKey]: 'N'
      });
    }
  })));
};
export default /*#__PURE__*/React.memo(NaturalDisasterAlertScreen);
//# sourceMappingURL=index.js.map